<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>部门设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">部门设置</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd()">
          <span>添加部门</span>
        </div>
      </div>
    </div>
    <div class="material">
      <div class="layout-content" style="background: transparent;">
        <Table :border="false" row-key="id" :columns="columns" :data="type" :load-data="handleLoadData"
          max-height='700'>
          <template slot-scope="{ row, index }" slot="name">{{ row.name }}</template>
          <template slot-scope="{ row, index }" slot="showIndex">{{ row.showIndex }}</template>
          <template slot-scope="{ row, index }" slot="action">
            <div v-if="row.type === 1">
              <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <span style="color: #1890ff;cursor: pointer;" @click="showSubAdd(row)">添加职务</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">删除</span>
              </Poptip>
            </div>
            <div v-else>
              <span style="color: #1890ff;cursor: pointer;" @click="editSubShow(row)">编辑</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <Poptip confirm title="确认是否删除?" @on-ok="delItemSub(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">删除</span>
              </Poptip>
            </div>
          </template>
        </Table>
      </div>

      <departmentAdd :show="show" @finish="init()" @close="show = false;" :options="options" :modelTitle="modelTitle" />
      <departmentAddChild :show="showChild" @finish="init()" @close="showChild=false;" :options="optionsChild"
        :modelTitle="modelTitle2" />

    </div>
  </div>
</template>

<script>
import departmentAdd from "../components/department-add.vue";
import departmentAddChild from "../components/department-child-add.vue";
import { mapActions } from "vuex";

export default {
  name: "host-set-pro-category",
  data () {
    return {
      columns: [
        {
          title: "部门名称",
          key: "name",
          tree: true,
        },
        {
          title: "显示顺序",
          key: "showIndex",
          width: "100px"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      classify: false,
      editClassify: false,
      editClassifyInfo: null,
      editclassifySub: false,
      editclassifySubInfo: null,
      type: [],
      parent1: null,
      show: false,
      showChild: false,
      options: {},
      modelTitle: '',
      modelTitle2: '',
      optionsChild: {},
    };
  },
  components: {
    departmentAdd,
    departmentAddChild
  },
  computed: {
    option () {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    },
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getDepartmentList: 'liveModule/getDepartmentList',
      delDepartment: 'liveModule/delDepartment',
      delDepartmentJob: 'liveModule/delDepartmentJob',
    }),
    async init () {
      let department = await this.getDepartmentList();
      console.log(department, 'department')
      if (department && department.length) {
        department.map(c => {
          c._showChildren = true;
          c.children = c.jobs;
          c.type = 1;
          c.num = c.jobs.length;
          if (c.num) {
            c._loading = false;
          }
        });
        this.type = department;
        console.log('department', department);
      } else {
        this.type = [];
      }
    },
    async delItem (item) {
      let result = await this.delDepartment(item.id);
      if (result) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async delItemSub (item) {
      let result = await this.delDepartmentJob(item.id);
      if (result) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    handleLoadData (item, callback) {
      const list = item.jobs;
      callback(list);
    },

    showAdd () { // 新增
      this.show = true;
      this.modelTitle = '添加部门';
      this.options = {
        model: null,
        msg: null,
      }
    },
    editShow (item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑部门';
      this.options = {
        model: 'edit',
        msg: item,
      }
    },
    showSubAdd (item) { // 新增
      this.showChild = true;
      this.modelTitle2 = '添加职务';
      this.optionsChild = {
        departmentId: item.id,
        model: null,
        msg: null,
      }
    },
    editSubShow (item) {
      this.showChild = true;
      this.modelTitle2 = '编辑职务';
      this.optionsChild = {
        model: 'edit',
        msg: item,
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;

  button {
    margin-right: 20px;
  }
}

.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}

.cate-item {
  width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; // 显示的行数
  overflow: hidden;
}

.layout-content {
  table {}
}
</style>

<style lang="scss">
.cate-item {
  width: 200px;

  &:hover {
    color: #1890ff;
  }
}

.cate-pop-item {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 6px;

  .cate-brand {
    display: inline-block;
    border: solid 1px #f0f0f0;
    background-color: #f5f5f5;
    padding: 0 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    color: #333;

    :hover {
      color: #333;
    }

    &-close {
      font-size: 21px;
      position: relative;
      top: 1px;
    }
  }
}
</style>

